import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import useVersionCheck from './hooks/useVersionCheck';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Employees from './pages/Employees';
import Absences from './pages/Absences';
import Reports from './pages/Reports';
import Records from './pages/Records';
import GenerateReports from './pages/GenerateReports';
import DailyHours from './pages/DailyHours';
import Holidays from './pages/Holidays';
import Timestamps from './pages/Timestamps';
import EarlyAuth from './pages/EarlyAuth';
import LateAuth from './pages/LateAuth';
import PtoManual from './pages/PtoManual';
import AuditLog from './pages/AuditLog';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/" replace />;
}

function PublicRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/" replace /> : children;
}

export default function App() {
  // Detecta despliegues nuevos y recarga automaticamente para reflejar los cambios
  // sin que el usuario tenga que borrar cache. Solo activo en produccion (build).
  useVersionCheck({ enabled: process.env.NODE_ENV === 'production' });

  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="employees" element={<Employees />} />
            <Route path="absences" element={<Absences />} />
            <Route path="reports" element={<Reports />} />
            <Route path="records" element={<Records />} />
            <Route path="generate" element={<GenerateReports />} />
            <Route path="daily-hours" element={<DailyHours />} />
            <Route path="holidays" element={<Holidays />} />
            <Route path="timestamps" element={<Timestamps />} />
            <Route path="early-auth" element={<EarlyAuth />} />
            <Route path="late-auth" element={<LateAuth />} />
            <Route path="pto-manual" element={<PtoManual />} />
            <Route path="audit-log" element={<AdminRoute><AuditLog /></AdminRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}
